import { useIntl } from 'react-intl';
import { Button, Tooltip } from '@rossum/ui/material';
import { UploadRestrictor } from '../../../components/Restrictors';

type Props = {
  onClick: () => void;
  disabled: boolean;
  tooltipTitle: string;
};
export const UploadButton = ({ onClick, disabled, tooltipTitle }: Props) => {
  const intl = useIntl();

  return (
    <UploadRestrictor>
      <Tooltip title={tooltipTitle}>
        <span>
          <Button
            color="secondary"
            variant="outlined"
            data-cy="upload-btn"
            disabled={disabled}
            onClick={onClick}
          >
            {intl.formatMessage({
              id: 'components.dashboard.queues.upload',
            })}
          </Button>
        </span>
      </Tooltip>
    </UploadRestrictor>
  );
};
